import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faPlus } from "@fortawesome/free-solid-svg-icons";
import Dropdown from "react-bootstrap/Dropdown";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import HobbiesList from "../Components/HobbiesList";
import { useTranslation } from "react-i18next";
import axios from "axios";
import "./Hobbies.css";

function Hobbies() {
  const [isLoading, setIsLoading] = useState(true);
  const [hobbies, setHobbies] = useState([]);

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/hobbies/gethobbies`,
        data: { language: state.language },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setHobbies(response.data.hobbies);
      setIsLoading(false);
    }
    fetch();
  }, [state.language, state.token]);

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row className="align-items-center">
          <Col lg={11} className="hobbies-header">
            <h2>{t("Hobbies.Titulo")}</h2>
          </Col>
          <Col lg={1} className="right hobbies-content">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faList} />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item as={Link} to={`/hobbies/new`}>
                  <FontAwesomeIcon icon={faPlus} /> {t("Hobbies.NuevoHobby")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
        <Row>
          {hobbies.length === 0 ? (
            <Col className="empty-hobbies center">
              <h5>{t("Hobbies.SinHobbies")}</h5>
            </Col>
          ) : (
            <HobbiesList hobbies={hobbies} language={state.language} />
          )}
        </Row>
      </Container>
    );
  }
}

export default Hobbies;
